import { render } from "./examLink.vue?vue&type=template&id=4d6ddb34&scoped=true"
import script from "./examLink.vue?vue&type=script&lang=js"
export * from "./examLink.vue?vue&type=script&lang=js"

import "./examLink.vue?vue&type=style&index=0&id=4d6ddb34&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-school.vip.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6ddb34"]])

export default __exports__